import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { NewGetSiteEventCollection, NewGetSiteEventCollectionResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<NewGetSiteEventCollectionResponse, NewGetSiteEventCollectionResponse>) => response?.data;
const getError = (response?: SWRResponse<NewGetSiteEventCollectionResponse, NewGetSiteEventCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<NewGetSiteEventCollectionResponse, NewGetSiteEventCollectionResponse>) => ({});

const useGetSiteEventGetCollection = (query?: Partial<NewGetSiteEventCollection>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new NewGetSiteEventCollection(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSiteEventGetCollection;